import { useState } from "react";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOPICS = [["demo", "Book a demo"], ["pricing", "Pricing"], ["support", "Help with my account"], ["general", "Something else"]];

export default function AssistantTicketForm({ sessionId, onDone }) {
  const [f, setF] = useState({ name: "", email: "", company: "", topic: "demo", message: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try {
      const r = await fetch(`${API}/assistant/ticket`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ ...f, session_id: sessionId }) });
      const d = await r.json();
      if (!r.ok) throw new Error(typeof d.detail === "string" ? d.detail : "Please check your details.");
      onDone(d.number);
    } catch (x) { setErr(x.message); } finally { setBusy(false); }
  };
  const cls = "w-full px-3 py-2 rounded-lg border border-slate-200 text-base sm:text-sm focus:outline-none focus:border-blue-500 bg-white";
  return (
    <form onSubmit={submit} className="rounded-xl border border-blue-100 bg-blue-50/50 p-3 space-y-2" data-testid="assistant-ticket-form">
      <div className="text-xs font-semibold text-slate-700">Leave your details — our team will reply by email</div>
      <input required value={f.name} onChange={set("name")} placeholder="Your name" className={cls} data-testid="ticket-name" />
      <input required type="email" value={f.email} onChange={set("email")} placeholder="Work email" className={cls} data-testid="ticket-email" />
      <input value={f.company} onChange={set("company")} placeholder="Company (optional)" className={cls} data-testid="ticket-company" />
      <select value={f.topic} onChange={set("topic")} className={cls} data-testid="ticket-topic">
        {TOPICS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
      <textarea required rows={3} value={f.message} onChange={set("message")} placeholder="How can we help?" className={cls} data-testid="ticket-message" />
      {err && <div className="text-xs text-rose-600" data-testid="ticket-error">{err}</div>}
      <button disabled={busy} className="w-full py-2 rounded-lg bg-slate-900 hover:bg-slate-800 text-white text-sm font-medium flex items-center justify-center gap-1.5" data-testid="ticket-submit">
        {busy && <Loader2 className="w-4 h-4 animate-spin" />} Send to RecruitSift team
      </button>
    </form>
  );
}
